"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridNotificationPlugin = void 0;
const react_1 = __importDefault(require("react"));
const GridNotificationBox_1 = require("./components/GridNotificationBox/GridNotificationBox");
const GridNotificationOverlay_1 = require("./components/GridNotificationOverlay/GridNotificationOverlay");
function gridNotificationPlugin(config) {
    return () => {
        return {
            bodyAddons: [
                {
                    id: 'grid-notification',
                    order: -99,
                    render: () => {
                        return (react_1.default.createElement(GridNotificationOverlay_1.GridNotificationOverlay, null,
                            react_1.default.createElement(GridNotificationBox_1.GridNotificationBox, { hasClose: !!config.onRequestClose, content: config.content, onRequestClose: config.onRequestClose })));
                    }
                }
            ]
        };
    };
}
exports.gridNotificationPlugin = gridNotificationPlugin;
//# sourceMappingURL=gridNotificationPlugin.js.map